export var SendErrorType;
(function (SendErrorType) {
    SendErrorType["SendError"] = "SendError";
})(SendErrorType || (SendErrorType = {}));
export class SendError extends Error {
    static isSendError(error) {
        return error.__type === SendErrorType.SendError;
    }
    constructor(message) {
        super(message);
        this.name = SendErrorType.SendError;
        this.__type = SendErrorType.SendError;
    }
}
//# sourceMappingURL=SendError.js.map